export class Features {
  public acceptorSearch = false;
  public accounts = false;
  public bankToWallet = false;
  public beneficiariesManagement = false;
  public beneficiariesUsage = false;
  public bicReferential = false;
  public billPayment = false;
  public cardSensitiveDataView = false;
  public cards = false;
  public clientInformationUpdate = false;
  public clientInformationView = false;
  public consultAuthorizationHolds = false;
  public consultLoans = false;
  public customerInstructionDeletion = false;
  public customerInstructionInitiation = false;
  public customerInstructionSubmit = false;
  public customerInstructionUpdate = false;
  public customerInstructionView = false;
  public externalAccountsManagement = false;
  public externalAccountsUsage = false;
  public externalLoanManagement = false;
  public identityDocumentView = false;
  public identityView = false;
  public trustedDevices = false;
  public manageCategorizationSpendings = false;
  public manageQrCode = false;
  public notifications = false;
  public p2pCashTransfer = false;
  public p2pDedicatedTransfer = false;
  public p2pSimpleTransfer = false;
  public p2pTransfer = false;
  public payment = false;
  public paymentContract = false;
  public paymentInstructionView = false;
  public paymentNetwork = false;
  public paymentStandingOrderCreate = false;
  public paymentStandingOrderView = false;
  public paymentStandingOrderUpdate = false;
  public paymentStandingOrderDelete = false;
  public payout = false;
  public pincodeUpdate = false;
  public recipientCreate = false;
  public savContractRead = false;
  public savDeposit = false;
  public savProductRead = false;
  public savContractWrite = false;
  public sdaAccountView = false;
  public sdaAccountsNameUpdate = false;
  public sdaAuthenticationsSessionsAuth = false;
  public sdaAuthenticationsSessionsView = false;
  public sdaCardView = false;
  public sdaCustomerOnboardingActionsInitiate = false;
  public sdaCustomerOnboardingCreate = false;
  public sdaCustomerOnboardingSubmit = false;
  public sdaCustomerOnboardingUpdate = false;
  public sdaCustomerOnboardingView = false;
  public sdaExchangeRateView = false;
  public sdaRequiredActionsWrite = false;
  public sdaTransactionsView = false;
  public strongCustomerAuthentication = false;
  public subscribeLoan = false;
  public transactionCode = false;
  public virtualCardCreation = false;
  public walletRechargeByCard = false;
  public withdraw = false;
  public partyAuthenticationManagement = false;
  public savDocumentsRead = false;
  public additionalDataRead = false;
  public mandateView = false;
  public mandateManagement = false;
}
